import { getHarmonyAppDefinitions } from '@office-start/mos-app-utilities';
import { localStorage } from '@office-start/owl-proxy';
import { cleanupOldOfficeHomeSideloadData, getPrefixedKey } from '../utils';
export var getLocalStorageSideloadApps = function (puid) {
    if (!localStorage) {
        console.error('Cannot save locally sideloaded apps with falsy localStorage.');
        return;
    }
    var key = getPrefixedKey(puid);
    try {
        cleanupOldOfficeHomeSideloadData(key);
        var appsJson = localStorage.getItem(key) || '[]';
        var acquisitionResponse = {
            acquisitions: JSON.parse(appsJson),
            syncKey: '',
            nextInterval: '',
            isFreshSyncKey: false,
        };
        return getHarmonyAppDefinitions(acquisitionResponse.acquisitions);
    }
    catch (err) {
        console.error("Problem loading locally sideloaded apps: ".concat(err));
    }
    return undefined;
};
//# sourceMappingURL=getLocalStorageSideloadApps.js.map